import { useCategories } from 'api/hooks/use-categories'
import { NavBarItem } from './nav-bar-item'
import { List } from '@mui/material'
import { NAV_BAR_HEIGHT } from 'app/constants'
import { memo, useCallback, useState } from 'react'

export const NavbarList = memo(() => {
  const { data: categories } = useCategories()
  const [openId, setOpenId] = useState<string | null>(null)
  const close = useCallback(() => setOpenId(null), [])

  return (
    <List
      component="nav"
      sx={{
        display: { xs: 'none', md: 'flex' },
        flexWrap: 'wrap',
        alignItems: 'center',
        width: '854px',
        height: NAV_BAR_HEIGHT,
      }}
    >
      {categories.map((category) => (
        <NavBarItem
          key={category.id}
          category={category}
          isOpen={openId === category.id}
          onOpen={setOpenId}
          onClose={close}
        />
      ))}
    </List>
  )
})
